export class Surgreffage {
    static jsonMap = {
        variete: { key: 'variete', optional: true },
        anneeSurgreffage: { key: 'anneeSurgreffage' },
        nbArbre: { key: 'nbArbre' }
    };

    public variete: number = undefined;
    anneeSurgreffage: number;
    nbArbre: number;
}
